module.exports = {"us":"Hodor","eu":"Hodor","cn":"Hodor","tw":"Hodor","kr":"Hodor","world":"Hodor"};